import * as Yup from "yup";
export const signupValidationsSchema = Yup.object().shape({
  company_name: Yup.string().required("The company name field is required"),
  first_name: Yup.string().required("The first name field is required"),
  last_name: Yup.string().required("The last name field is required"),
  email: Yup.string()
    .email("The email format is invalid")
    .required("The email field is required"),
  country: Yup.string().required("The country field is required"),
  mobile_number: Yup.string().required("The phone number field is required"),
  address: Yup.string().required("The address field is required"),
  city: Yup.string().required("The city field is required"),
  state: Yup.string().required(" The state field is required"),
  zip: Yup.string().required("The zip field is required"),
  auctioner_licenses: Yup.string().required(
    "The auctioner lisence field is required"
  ),
  password: Yup.string().required("The password field is required"),
  retypePassword: Yup.string().oneOf(
    [Yup.ref("password"), ""],
    "your password is not matched with confirm password"
  ),
  website: Yup.string()
    .url("The URL field is invalid")
    .required("The URL field  is required"),
});
export const loginValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email("Please enter valid email address")
    .required("The email field is required"),
  password: Yup.string().required("password is required"),
});
export const SendEmailValildationsSchema = Yup.object().shape({
  email: Yup.string()
    .email("Please enter valid email address")
    .required("The email field is required"),
});
export const forgotPasswordValidationSchema = Yup.object().shape({
  new_password: Yup.string().required("New password  is required"),
  confirm_password: Yup.string().oneOf(
    [Yup.ref("new_password"), ""],
    "your new password is not matched with confirm password"
  ),
});

export const addCategoryValidationSchema = Yup.object().shape({
  name: Yup.string().required("The name field  is required"),
  description: Yup.string().required("The description field  is required"),
});
export const createAuctionsValidationSchema = Yup.object().shape({
  title: Yup.string().required("The name field  is required"),
  description: Yup.string().required(" The description field  is required"),
  date: Yup.string().required("Please select date"),
  address: Yup.string().required("The address field is required"),
  city: Yup.string().required(" The city field is required"),
  state: Yup.string().required("The state field is required"),
  category_id: Yup.string().required("The category field is required"),
});
